import React, { useEffect } from 'react';
import HealtheraTable from '../Table/Table';
import { Loading } from '../../healtheraComponents';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../redux/organisations';
import { withRouter } from 'react-router';

const prepareData = (apps = []) => {
  return apps.reduce((data, app = {}) => {
    const { _id, name, bundle_id, organisationCount } = app;

    data.push({
      view: {
        name: name,
        bundleId: bundle_id,
        organisationCount,
      },
      ID: _id,
      route: 'whitelabels',
    });

    return data;
  }, [{
    view: {
      name: 'Name',
      bundleId: 'Bundle ID',
      organisationCount: 'Organisations',
    },
    headers: true
  }])
};

const WhiteLabelList = (props) => {
  const { whiteLabelApps, fetching } = useSelector(state => state.organisations);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getWhiteLabelApps());
    dispatch(actions.showTabIcon(false));
  }, [dispatch]);

  return (
    <>
      {!fetching && whiteLabelApps && (
        <HealtheraTable
          muted={true}
          paddingtop={`27px`}
          data={prepareData(whiteLabelApps)}
        />
      )}
      <Loading loading={fetching} />
    </>
  );
};

export default withRouter(WhiteLabelList);
